import axios from "axios";

export const UPLOAD_RECEIPTS_FOR_EXTRACTION = `/api/v1/customer/receipts`;

export function uploadReceipts(files, restaurantStoreId) {
  const formData = new FormData();
  // Append each file to the form data
  files.forEach((file, index) => {
    formData.append("files", file); // or use `files[]` if backend expects it
  });
  // Append the restaurantStoreId
  formData.append("restaurantStoreId", restaurantStoreId);
  return axios.post(UPLOAD_RECEIPTS_FOR_EXTRACTION, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    validateStatus(status) {
      return true;
    },
  });
}

export function getRestaurantList() {
  return axios.get(`/api/v1/customer/restaurants`, {
    validateStatus(status) {
      return true;
    },
  });
}

export function searchRestaurantStores(q = "") {
  return axios.get(`/api/v1/customer/restaurants/search`, {
    params: { q },
    validateStatus(status) {
      return true;
    },
  });
}

export function updateReceipt(receiptID, data) {
  return axios.put(`/api/v1/customer/receipts/${receiptID}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

export function getSingleReceipt(receiptID) {
  return axios.get(`/api/v1/customer/receipts/${receiptID}`, {
    validateStatus(status) {
      return true;
    },
  });
}
